export const config = {
  title: "Diallo Realty Group | Real Estate in Cincinnati, OH",
  meta: {
    description:
      "Diallo Realty Group provides trusted real estate services in Cincinnati, OH. We specialize in residential consultation, property placement, market analysis, property management, relocation support, and real estate advisory.",
    keywords: [
      "Diallo Realty Group",
      "real estate Cincinnati",
      "residential consultation",
      "property management Cincinnati",
      "real estate advisory",
      "home buying Cincinnati",
      "relocation services"
    ],
    author: "Diallo Realty Group",
    canonicalUrl: "https://diallorealtygroup.com/",
  },
  sections: {
    header: {
      businessName: "Diallo Realty Group",
    },
    sectionB: {
      heroTitle: "More Than a Transaction, It's a Relationship",
      heroSubtitle: "Trusted Real Estate Guidance in Cincinnati, OH",
      learnAboutText: "Explore Our Services",
      phoneNumber: "3193315981",
      phoneLabel: "(319) 331-5981",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2163132165/photo/houses-align-a-residential-district-next-to-road.jpg?s=612x612&w=0&k=20&c=JwTatZ7qyrv0s0UZa6yZ_WpByb_0M7GN9ZXZQOrWWRk=",
      cardData: [
        {
          title: "Residential Consultation",
          description:
            "Guidance from start to finish in finding your dream home.",
        },
        {
          title: "Property Management",
          description:
            "Comprehensive management of your rental properties with professional care.",
        },
        {
          title: "Relocation Support",
          description:
            "Helping families and individuals transition smoothly to new communities.",
        },
      ],
      description:
        "Diallo Realty Group is dedicated to transforming the real estate experience into a personalized, seamless journey. From buying and selling to management and relocation, we ensure every client is supported with integrity and care.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive real estate services designed to meet your personal and investment goals.",
      cards: [
        {
          title: "Residential Consultation",
          description:
            "Expert advice and support in finding and securing your new home.",
          imageSrc: "https://media.istockphoto.com/id/932275488/photo/real-estate.jpg?s=612x612&w=0&k=20&c=mfnmAYhfeCHDDqS3rve6JtXW6lpPSQCajJ6sQYRvvo4=",
          imageAlt: "Residential Consultation",
        },
        {
          title: "Property Placement Services",
          description:
            "Strategic placement services to connect your property with the right occupants.",
          imageSrc: "https://media.istockphoto.com/id/1384098518/photo/real-estate-professionals-offer-their-clients-contracts-to-discuss-home-purchases-insurance.jpg?s=612x612&w=0&k=20&c=zqUE2VL0SvnUM8iIKVXBes-mBjcjr35IY6AAwGbAp9g=",
          imageAlt: "Property Placement",
        },
        {
          title: "Market Analysis",
          description:
            "Detailed market insights to help you make informed real estate decisions.",
          imageSrc: "https://media.istockphoto.com/id/1339819529/photo/at-hand-of-a-real-estate-salesman-who-calculates-with-a-calculator.jpg?s=612x612&w=0&k=20&c=Yo42wNX3dUakOvby38XlJSwZqiXT7hi_RwvBIELE3B4=",
          imageAlt: "Market Analysis",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Property Management",
        "Community Relocation",
        "Real Estate Advisory",
      ],
    },
    sectionD: {
      aboutTitle: "About Diallo Realty Group",
      aboutImage: {
        src: "https://diallorealtygroup.com/gallery_gen/add75929b4f752cffe9ff489b89c864a_710.26198083067x472_fill.jpg",
        alt: "Diallo Realty Group Team",
      },
      aboutText: [
        "Diallo Realty Group was founded by Adama Diallo with the vision of transforming real estate into a client-first, relationship-driven experience.",
        "We are committed to integrity, transparency, and community impact, ensuring that every client feels supported and empowered throughout their real estate journey.",
      ],
    },
    sectionE: {
      profileImage: "https://diallorealtygroup.com/gallery_gen/d64c92f3eadaed0a9b1dd0dc7c187d21_fit.jpg?ts=1757956262",
      profileAlt: "Diallo Realty Group Logo",
      businessName: "Diallo Realty Group",
      contact: {
        phone: "3193315981",
        phoneLabel: "(319) 331-5981",
        email: "mdiallo1217@gmail.com",
        website: "https://diallorealtygroup.com/",
        address: "1500 Groesbeck Rd #513, Cincinnati, OH 45224",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: "1500 Groesbeck Rd #513, Cincinnati, OH 45224",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.390713145111!2d-84.5553!3d39.1968!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8841b4d54dcbf5b5%3A0xabcdef123456789!2s1500%20Groesbeck%20Rd%20%23513%2C%20Cincinnati%2C%20OH%2045224!5e0!3m2!1sen!2sus!4v1714567890123!5m2!1sen!2sus",
    },
  },
};

export default config;
